import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import VolumeOnIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import Fullscreen from '@material-ui/icons/Fullscreen';
import FullscreenExit from '@material-ui/icons/FullscreenExit';
import classnames from 'classnames';
import React from 'react';

const styles = {
  player: {
    flex: 1,
    background: '#000',
    position: 'relative',
    '& > div': {
      margin: 0,
      border: 'none',
      boxShadow: 'none'
    },
    '&:hover': {
      '& $controlsWrapper': {
        display: 'flex'
      }
    }
  },
  controlsWrapper: {
    display: 'none',
    position: 'absolute',
    zIndex: 100,
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 2,
    width: '100%',
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    color: '#fff',
    cursor: 'pointer',
    '& > button': {
      padding: '0 5px'
    }
  },
  playerWrapper: {
    display: 'flex',
    position: 'absolute',
    zIndex: 9,
    width: '100%',
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    cursor: 'pointer'
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#000',
    flexDirection: 'column',
    zIndex: 2,
    color: '#fff',
    '& > svg': {
      color: '#fff',
      fontSize: 72,
      opacity: 0.6
    }
  },
  playerSource: {
    width: '100% !important',
    height: '100% !important',
    background: 'transparent'
  }
};

class Webrtc extends React.Component {
  state = {
    mute: true,
    fullScreen: 0
  };

  /* tslint:disable */
  componentDidMount() {
    this.handlePlayer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url && prevProps.url !== '') {
      /* eslint-disable */
      webrtcStreaming.destroy(prevProps.id);
      this.handlePlayer();
    }
  }

  handlePlayer = () => {
    let url = JSON.parse(JSON.stringify(this.props.url));
    const iceServers =
      (this.props.iceServers &&
        this.props.iceServers.length !== 0 &&
        this.props.iceServers) ||
      (globalThis.UI_CONFIG &&
        globalThis.UI_CONFIG.webrtc_config &&
        globalThis.UI_CONFIG.webrtc_config.ice_server_details.ice_servers) ||
      (globalThis.UI_CONFIG && globalThis.UI_CONFIG.ice_servers) ||
      [];
    const iceTransportPolicy =
      this.props.iceTransportPolicy ||
      (globalThis.UI_CONFIG &&
        globalThis.UI_CONFIG.webrtc_config &&
        globalThis.UI_CONFIG.webrtc_config.ice_server_details
          .ice_transport_policy);
    const useWebSocketForWebRTC =
      !this.props.useWebSocketForWebRTC ||
      (globalThis.UI_CONFIG &&
        globalThis.UI_CONFIG.webrtc_config &&
        globalThis.UI_CONFIG.webrtc_config.ice_server_details
          .use_websocket_for_webrtc);

    if (Array.isArray(url)) {
      if (!useWebSocketForWebRTC) {
        url = url.filter(str => str.indexOf('wss://') === -1);
      }

      // This is required, otherwise if empty array is passed to janus, it will crash
      if (url.length === 0) {
        url.push('');
      }
    }

    window.webrtcStreaming(url, this.props.id, 1, {
      debug: false, //(window.blip.webrtc && window.blip.webrtc.debugMode) ||
      width: '100%',
      height: '100%',
      bitrate: 'bitrate',
      iceServers,
      iceTransportPolicy
    });
    webrtcStreaming.mute(this.props.id, this.state.mute);
    document.addEventListener(
      'fullscreenchange',
      this.changedFullscreen,
      false
    );
  };

  componentWillUnmount() {
    if (this.props.id) {
      webrtcStreaming.destroy(this.props.id);
    }
    document.removeEventListener(
      'fullscreenchange',
      this.changedFullscreen,
      false
    );
  }

  changedFullscreen = () => {
    this.setState(() => {
      const fullScreen = this.state.fullScreen === 0 ? 1 : 0;
      return { fullScreen };
    });
  };

  toggleMute = event => {
    event.stopPropagation();
    this.setState(() => {
      const mute = !this.state.mute;
      webrtcStreaming.mute(this.props.id, mute);
      return { mute };
    });
  };

  handleScreen = event => {
    event.stopPropagation();
    const playerElem = document.getElementById(this.props.id).parentElement;
    if (this.state.fullScreen === 0) {
      if (playerElem.requestFullscreen) {
        playerElem.requestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  /* tslint:enable */

  render() {
    const { classes, type } = this.props;

    return (
      <div className={classes.player}>
        <div
          className={classnames('webrtcStreaming', classes.playerSource)}
          id={this.props.id}
        />
        <div className={classes.controlsWrapper}>
          <IconButton onClick={this.toggleMute} color="inherit">
            {this.state.mute ? <VolumeOffIcon /> : <VolumeOnIcon />}
          </IconButton>
          <IconButton onClick={this.handleScreen} color="inherit">
            {this.state.fullScreen === 0 ? <Fullscreen /> : <FullscreenExit />}
          </IconButton>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Webrtc);



